import { TEXT_IMPORT_EXTENSIONS } from '../config';
import type { ImportFileKind } from '../config';

const getImportFileExtension = (fileName: string): string =>
  fileName.split('.').pop()?.toLowerCase() ?? '';

export const getImportFileKind = (file: File): ImportFileKind => {
  const extension = getImportFileExtension(file.name);

  if (extension === 'json') {
    return 'json';
  }
  if (TEXT_IMPORT_EXTENSIONS.includes(extension)) {
    return 'text';
  }

  return 'unsupported';
};
